import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/registration-confirmed")({
  staticData: { sitemap: false },
  head: () => ({
    meta: [
      { title: "Registration received — Foreign Council On Economic Relations" },
      { name: "description", content: "Thank you for your registration with the Foreign Council On Economic Relations." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Registration received — Foreign Council" },
      { property: "og:description", content: "Thank you for your registration. We will review it and get back to you shortly." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: RegistrationConfirmedPage,
});

function RegistrationConfirmedPage() {
  return (
    <section className="bg-surface">
      <div className="mx-auto w-full max-w-[900px] px-5 py-16 lg:px-8 lg:py-20">
        <h1 className="fc-h2 fc-rule text-foreground">Thank you for your registration</h1>
        <div className="mt-10 space-y-5 bg-card p-6 lg:p-10">
          <p className="fc-body text-foreground">We have received your registration.</p>
          <p className="fc-body text-muted-foreground">
            Your registration will now be reviewed. We will get back to you shortly with a confirmation.
          </p>
          <p className="fc-body text-muted-foreground">
            If you have any questions in the meantime, please contact us at reg @ foreign-council.org.
          </p>
          <Link to="/" className="fc-body inline-block bg-primary px-6 py-3 text-primary-foreground focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring">
            Back to homepage
          </Link>
        </div>
      </div>
    </section>
  );
}
